import { render, staticRenderFns } from "./IncludedPlatforms.vue?vue&type=template&id=56b9fd78&"
import script from "./IncludedPlatforms.vue?vue&type=script&lang=js&"
export * from "./IncludedPlatforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports